import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { useWorkspace } from '../../contexts/WorkspaceContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// "Copy to…" — duplicates a contact into Personal or another Business workspace.
export const CopyContactToWorkspace = ({ contact }) => {
  const { workspaces = [], isBusinessEnabled } = useWorkspace() || {};
  const [busyId, setBusyId] = useState(null);
  const sourceId = contact.org_id || 'personal';
  const targets = workspaces.filter((w) => w.id !== sourceId);
  if (!isBusinessEnabled || targets.length === 0) return null;

  const copyTo = async (w) => {
    setBusyId(w.id);
    try {
      await axios.post(
        `${API}/contacts/${contact.id}/copy`,
        { target_org_id: w.kind === 'org' ? w.id : null },
        { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
      );
      toast.success(`Copied to ${w.name}`);
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'Could not copy this contact');
    } finally {
      setBusyId(null);
    }
  };

  return (
    <div className="mobile-card p-6 mb-4" data-testid="copy-contact-section">
      <p className="text-sm font-semibold text-gray-900 mb-1">Copy to another workspace</p>
      <p className="text-xs text-gray-500 mb-3">Creates a separate copy — edits to one won't change the other.</p>
      <div className="flex flex-wrap gap-2">
        {targets.map((w) => (
          <button
            key={w.id}
            onClick={() => copyTo(w)}
            disabled={!!busyId}
            data-testid={`copy-contact-to-${w.id}`}
            className="inline-flex items-center gap-1.5 px-3 py-2 rounded-lg border border-indigo-200 text-sm font-medium text-indigo-700 hover:bg-indigo-50 disabled:opacity-60 transition-colors"
          >
            <span aria-hidden="true">{w.kind === 'org' ? '🏢' : '👤'}</span>
            {busyId === w.id ? 'Copying…' : `Copy to ${w.name}`}
          </button>
        ))}
      </div>
    </div>
  );
};
